export enum OOBStatusTypes {
    INCOMPLETE = "incomplete",
    COMPLETE = "complete",
    WAIT = "wait",
    PASS = "pass",
    FAIL = "fail",
    PIN = "pin"
}